import { Divider, Form, Radio, Slider } from "antd";
import { AlignLeftOutlined, AlignCenterOutlined, AlignRightOutlined } from "@ant-design/icons";
import ContentPadding from "../ContentConfig/ContentPadding";
import { ColorPickerFormItem } from "../Image/ImageConf";
import ContentID from "../Common/ContentID";

export default ({ node }) => {
  return (
    <>
      <Form.Item label="Width" name="width">
        <Slider style={{width: "90%"}} min={0} max={100} marks={{ 0: "-", 100: "+" }} tipFormatter={(v) => `${v}%`} />
      </Form.Item>
      <Form.Item label="Height" name="height">
        <Slider style={{width: "90%"}} min={0} max={30} marks={{ 0: "-", 30: "+" }}/>
      </Form.Item>
      <Form.Item label="Style" name="style">
        <Radio.Group buttonStyle="solid">
          <Radio.Button value="solid">Solid</Radio.Button>
          <Radio.Button value="dotted">Dotted</Radio.Button>
          <Radio.Button value="dashed">Dashed</Radio.Button>
        </Radio.Group>
      </Form.Item>

      <ColorPickerFormItem
        label={"Color"}
        name="color"
        color={node.data.color}
      />
      
      <Form.Item label="Alignment" name="align">
        <Radio.Group 
          style={{ margin: "12px 0 0 0" }}
          options={[
            { label: <AlignLeftOutlined />, value: 'left' },
            { label: <AlignCenterOutlined />, value: 'center' },
            { label: <AlignRightOutlined />, value: 'right' },
          ]}
          defaultValue="center"
          optionType="button"
        />
      </Form.Item>
      <Divider />
      <ContentID />
      <Divider />
      <ContentPadding />
    </>
  );
};
